// 電話番号リンクの表示制御
export const initTelLinkControl = () => {
  const setTelLinkVisibility = () => {
    const userAgent = navigator.userAgent;
    let showTelLink = false;

    // iOS (iPhone) の判定
    if (/iPhone/.test(userAgent)) {
      showTelLink = true;
    }
    // Android (Mobile) の判定
    else if (/Android/.test(userAgent) && /Mobile/.test(userAgent)) {
      showTelLink = true;
    }
    // それ以外（Windows / macOS / iOS (iPad) / Android (Mobileを含まない)）
    else {
      showTelLink = false;
    }

    // 電話番号を含む要素にクラスを追加
    const telElements = document.querySelectorAll('.number');
    telElements.forEach(element => {
      if (showTelLink) {
        element.classList.add('show-tel-link');
        element.classList.remove('hide-tel-link');
      } else {
        element.classList.add('hide-tel-link');
        element.classList.remove('show-tel-link');
      }
    });
  };

  // DOM読み込み完了後に実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setTelLinkVisibility);
  } else {
    setTelLinkVisibility();
  }
};